<template>
  <div class="compact-form">
    <osv-app-alert osv-alert-position="osv-alert-relative"/>

    <alert-message
        type="success"
        v-if="confirmed"
        :messages="$t('yourAccountIsConfirmed')"
    />

    <form class="subscribe-to-newsletter-form" @submit.prevent="subscribe">
      <!-- Email -->
      <div class="form-group">
        <b-field grouped label-position="on-border">
          <b-input
              :placeholder="$t('email')"
              v-model="email"
              class="subscribe-to-newsletter-email"
              type="email"
              expanded
              required
              rounded
          />
          <p class="control">
            <b-button
                native-type="submit"
                class="subscribe-to-newsletter-btn loadable-button"
                rounded
            >
              {{ $t('submit') }}
            </b-button>
          </p>
        </b-field>
      </div>
    </form>
  </div>
</template>

<script>
import { LocaleMixin } from "@/mixins/LocaleMixin";
import { HelpersMixin } from "@/mixins/HelpersMixin";
import { ConfigMixin } from "@/mixins/ConfigMixin";
import AlertMessage from "../components/shared/AlertMessage";
import VueI18n from "vue-i18n";
import OsvAppAlert from "@/components/shared/OsvAppAlert";
import cug from "@/services/cug";

export default {
  name: "NewsletterSubscriptionForm",
  mixins: [LocaleMixin, HelpersMixin, ConfigMixin],
  components: {OsvAppAlert, AlertMessage},

  data() {
    return {
      email: "",
      errorMessage: [],
      confirmed: null
    };
  },

  mounted() {
    this.$i18n.locale = this.getLocale();
  },

  methods: {
    subscribe: function () {
      this.errorMessage = [];

      this.loadButton(true);
      cug
          .subscribeToNewsletter({
            email: this.email
          })
          .then(() => {
            this.confirmed = true;
          })
          .catch(() => {
            this.$root.$emit("OsvAlert_ErrorFromApi", 'newsletter_subscribe');
          })
          .then(() => {
            this.loadButton(false);
          });
    }
  },

  i18n: new VueI18n({
    locale: "fr",
    messages: {
      en: {
        email: "Email",
        submit: "Subscribe",
        yourAccountIsConfirmed: "Thank you for registering, we'll be in touch!"
      },
      fr: {
        email: "Email",
        submit: "S'inscrire",
        yourAccountIsConfirmed: "Merci de vous être inscrit(e), on reste en contact !"
      }
    }
  })
};
</script>

<style lang="scss" src="../assets/styles/buefy/base.scss"></style>

<style lang="scss">
.subscribe-to-newsletter-form {
  .subscribe-to-newsletter-btn {
    height: 100%;
    background-color: #526467;
    color: white;
    border: none;
  }
  .subscribe-to-newsletter-email {
    input {
      background-color: rgba(255,255,255,0.2);
      color: white;
      &::placeholder {
        color: white;
      }
    }
  }
}
</style>
